import React from 'react';
import { Wallet, Shield, MapPin, Search } from 'lucide-react';
export function WhyChooseUs() {
  const benefits = [{
    icon: <Wallet className="w-8 h-8 text-white" data-id="element-275" />,
    title: 'No full payment until the job is done',
    description: "We don't ask for final payment until your roof is complete and you are 100% satisfied with our work."
  }, {
    icon: <Shield className="w-8 h-8 text-white" data-id="element-276" />,
    title: 'Lifetime labor warranty on all roofing',
    description: 'We stand behind our craftsmanship. Every full roof replacement comes with our lifetime labor guarantee.'
  }, {
    icon: <MapPin className="w-8 h-8 text-white" data-id="element-277" />,
    title: 'Multiple locations, so help is always nearby',
    description: 'With our HQ in Hurst and crews across DFW, we can respond quickly when storms hit your neighborhood.'
  }, {
    icon: <Search className="w-8 h-8 text-white" data-id="element-278" />,
    title: 'Free, no-obligation roof inspections',
    description: "Honest assessments. If you don't need a new roof, we'll tell you. We only recommend what's necessary."
  }];
  return <section id="why-us" className="py-20 bg-tx-light" data-id="element-279">
      <div className="container mx-auto px-4" data-id="element-280">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-281">
          <div data-id="element-282">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold text-tx-deep mb-6 tracking-tight" data-id="element-283">
              The Best Professional Roofing in Texas
            </h2>
            <p className="text-lg text-tx-body leading-relaxed mb-8" data-id="element-284">
              Since 2017 we've built our reputation on integrity and honesty.
              Transparent pricing, fast hard-working crews, the best materials,
              and customers first.
            </p>

            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-video" data-id="element-285">
              <img src="https://cdn.magicpatterns.com/uploads/dTgu5cEGfoxEus8PnEsJyW/TXD-Roofing7.jpg" alt="Texas Direct installer laying premium slate shingles on a residential roof" className="w-full h-full object-cover" data-id="element-286" />
              <div className="absolute inset-0 bg-tx-navy/10" data-id="element-287"></div>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-8" data-id="element-288">
            {benefits.map((benefit, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-289">
                <div className="w-14 h-14 bg-tx-navy rounded-xl flex items-center justify-center mb-6 shadow-inner" data-id="element-290">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-bold text-tx-deep mb-3 leading-tight" data-id="element-291">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm" data-id="element-292">
                  {benefit.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}